import { useSignForm } from '@shared/components/forms/sign'
import { useFormik } from 'formik'

import { sendStep1SignForm } from './api'
import { View } from './view'

export const SignFormStep1LkClient = () => {
	const { consentTypes, nextStep } = useSignForm()

	const formik = useFormik<Record<string, boolean>>({
		initialValues: consentTypes.ids.reduce((acc, curr) => {
			acc[curr] = true
			return acc
		}, {} as Record<string, boolean>),
		validateOnMount: true,
		enableReinitialize: true,

		async onSubmit(_, actions) {
			actions.setSubmitting(true)
			try {
				await sendStep1SignForm()
				nextStep()
			} catch (error: any) {
				if (error?.status === 403) {
					alert('Документы уже подписаны')
				}

				actions.setSubmitting(false)
			}
		},
	})

	return View({
		formik,
	})
}
